import { render, staticRenderFns } from "./Wordcloud.vue?vue&type=template&id=3be4d6fc"
import script from "./Wordcloud.vue?vue&type=script&lang=js"
export * from "./Wordcloud.vue?vue&type=script&lang=js"
import style0 from "./Wordcloud.vue?vue&type=style&index=0&id=3be4d6fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports